export default [
  {
    path: '/health-categories',
    name: 'health-category',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-healt/health-category/index-v2.vue')
  },
  {
    path: '/health-categories/:id',
    name: 'health-category-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/student-healt/health-category/index.vue'),
    props: route => ({ editData: route.params.editData }),
  }
]
